import { render, staticRenderFns } from "./partnerMng.vue?vue&type=template&id=47fe11d2"
import script from "./partnerMng.vue?vue&type=script&lang=js"
export * from "./partnerMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports